import { OPEN_OBJECTIVE_CREATION_MODAL, CLOSE_OBJECTIVE_CREATION_MODAL } from 'actions/actionTypes';

export const openObjectiveCreationModalAction = ({
  onClose,
  onSelect,
  enableCreation,
  allowTimePeriodChange = true,
  selectedTimeBoundPeriod = null,
  selectedObjective = null,
}) => ({
  type: OPEN_OBJECTIVE_CREATION_MODAL,
  onClose,
  onSelect,
  enableCreation,
  allowTimePeriodChange,
  selectedTimeBoundPeriod,
  selectedObjective,
});

export const closeObjectiveCreationModalAction = () => ({
  type: CLOSE_OBJECTIVE_CREATION_MODAL,
});
